export const MODAL_WIDTH = '1248px';
export const MODAL_HEIGHT = '100%';

export const MAX_SHARE_SKILLS_SELECTION = 5;
